"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = addClass;

var _hasClass = _interopRequireDefault(require("./hasClass"));

/**
 * Adds specific class to a given element
 *
 * @param target The element to add class to
 * @param className The class to be added
 *
 * @returns The target element
 */
function addClass(target, className) {
  if (className) {
    if (target.classList) {
      target.classList.add(className);
    } else if (!(0, _hasClass["default"])(target, className)) {
      target.className = target.className + " " + className;
    }
  }

  return target;
}

module.exports = exports.default;